import { get } from '../utilities/api'

export const getAccommodationTypes = params => get({
  url: '/accommodationtypes',
  params
})
